import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ThemeRtlProvider from './ThemeRtlProvider';

const styles = {
  root: {
    display: 'block',
  },
  content: {
    flexGrow: 1,
    backgroundColor: '#fff',
    minHeight: '90vh',
  },
};

const LayoutWithSidebar = ({ classes, component: Component }) => (
  <ThemeRtlProvider>
    <div className={classes.root}>
      <main className={classes.content}>
        <Component />
      </main>
    </div>
  </ThemeRtlProvider>
);

LayoutWithSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
};

export default withStyles(styles)(LayoutWithSidebar);
